import {
  createAsyncThunk,
  AnyAction,
  PayloadAction,
  createSlice,
} from "@reduxjs/toolkit";
import { VoxbayInitialStateDTO } from "./types";
import {
  AddVoxbayAgents,
  CallVoxbayLead,
  ConnectVoxbay,
  DeactivateVoxbay,
  VoxbayAddLeadForUnknown,
} from "./integrations.request";
import { setToastNotification } from "../../../../components/ToastNotification/service/toastNotificationSlice";

export const initialState: VoxbayInitialStateDTO = {
  voxbayConnectionLoading: false,
  voxbayConnectionSuccess: false,
  voxbayConnectionError: false,
  addVoxbayLoading: false,
  addVoxbaySuccess: false,
  addVoxbayError: false,
  uninstallVoxbayLoading: false,
  uninstallVoxbaySuccess: false,
  uninstallVoxbayError: false,
  voxbayWidgetShow: false,
  voxbayWidgetNumber: "",
  voxbayClickToCallLoading: false,
  voxbayClickToCallSuccess: false,
  voxbayClickToCallError: false,
  voxbayAddLeadForUnknownLoading: false,
  voxbayAddLeadForUnknownSuccess: false,
  voxbayAddLeadForUnknownError: false,
  voxbayAddLeadForUnknownData: null,
};

export const voxbayConnect = createAsyncThunk(
  "voxbay/voxbayConnect",
  async (body: any, thunkAPI: any) => {
    return ConnectVoxbay(body)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const addVoxbayAgent = createAsyncThunk(
  "voxbay/addVoxbayAgent",
  async (body: any, thunkAPI: any) => {
    return AddVoxbayAgents(body)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const deactivateVoxbay = createAsyncThunk(
  "voxbay/deactivateVoxbay",
  async (body: any, thunkAPI: any) => {
    return DeactivateVoxbay(body)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const voxbayClickToCall = createAsyncThunk(
  "voxbay/voxbayClickToCall",
  async (body: any, thunkAPI: any) => {
    return CallVoxbayLead(body)
      .then((response: any) => {
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const VoxbayAddLeadForUnknowns = createAsyncThunk(
  "voxbay/VoxbayAddLeadForUnknown",
  async (body: any, thunkAPI: any) => {
    return VoxbayAddLeadForUnknown(body)
      .then((response: any) => {
        if (response) {
          thunkAPI.dispatch(
            setToastNotification({
              message: response?.data?.message,
              type: "success",
              snackOpen: true,
            })
          );
        }
        return response?.data?.data;
      })
      .catch(function (e: any) {
        thunkAPI.dispatch(
          setToastNotification({
            message: e?.response?.data?.message,
            type: "error",
            snackOpen: true,
          })
        );
        throw e.response.data;
      });
  }
);

export const voxbaySlice = createSlice({
  name: "voxbay",
  initialState,
  reducers: {
    reset: () => initialState,
    resetVoxbayConnectSuccess: (state) => {
      state.voxbayConnectionSuccess = false;
    },
    resetAddVoxbayAgentSuccess: (state) => {
      state.addVoxbaySuccess = false;
    },
    resetDeactivateVoxbaySuccess: (state) => {
      state.uninstallVoxbaySuccess = false;
    },
    setShowVoxbayWidget: (state) => {
      state.voxbayWidgetShow = true;
    },
    setHideVoxbayWidget: (state) => {
      state.voxbayWidgetShow = false;
    },
    setShowVoxbayNumber: (state, action) => {
      state.voxbayWidgetNumber = action.payload;
    },
    resetVoxbayClickToCallSuccess: (state) => {
      state.voxbayClickToCallSuccess = false;
    },
    resetVoxbayAddLeadForUnknownSuccess: (state) => {
      state.voxbayAddLeadForUnknownSuccess = false;
      state.voxbayAddLeadForUnknownData = null;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(
      voxbayConnect.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.voxbayConnectionLoading = false;
        state.voxbayConnectionSuccess = true;
        state.voxbayConnectionError = false;
      }
    );
    builder.addCase(voxbayConnect.rejected, (state, action: AnyAction) => {
      state.voxbayConnectionLoading = false;
      state.voxbayConnectionSuccess = false;
      state.voxbayConnectionError =
        action?.error?.message || "Something went wrong";
    });
    builder.addCase(voxbayConnect.pending, (state) => {
      state.voxbayConnectionLoading = true;
      state.voxbayConnectionSuccess = false;
      state.voxbayConnectionError = false;
    });
    builder.addCase(
      addVoxbayAgent.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.addVoxbayLoading = false;
        state.addVoxbaySuccess = true;
        state.addVoxbayError = false;
      }
    );
    builder.addCase(addVoxbayAgent.rejected, (state, action: AnyAction) => {
      state.addVoxbayLoading = false;
      state.addVoxbaySuccess = false;
      state.addVoxbayError = action?.error?.message || "Something went wrong";
    });
    builder.addCase(addVoxbayAgent.pending, (state) => {
      state.addVoxbayLoading = true;
      state.addVoxbaySuccess = false;
      state.addVoxbayError = false;
    });
    builder.addCase(
      deactivateVoxbay.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.uninstallVoxbayLoading = false;
        state.uninstallVoxbaySuccess = true;
        state.uninstallVoxbayError = false;
      }
    );
    builder.addCase(deactivateVoxbay.rejected, (state, action: AnyAction) => {
      state.uninstallVoxbayLoading = false;
      state.uninstallVoxbaySuccess = false;
      state.uninstallVoxbayError =
        action?.error?.message || "Something went wrong";
    });
    builder.addCase(deactivateVoxbay.pending, (state) => {
      state.uninstallVoxbayLoading = true;
      state.uninstallVoxbaySuccess = false;
      state.uninstallVoxbayError = false;
    });
    builder.addCase(
      voxbayClickToCall.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.voxbayClickToCallLoading = false;
        state.voxbayClickToCallSuccess = true;
        state.voxbayClickToCallError = false;
      }
    );
    builder.addCase(voxbayClickToCall.rejected, (state, action: AnyAction) => {
      state.voxbayClickToCallLoading = false;
      state.voxbayClickToCallSuccess = false;
      state.voxbayClickToCallError =
        action?.error?.message || "Something went wrong";
    });
    builder.addCase(voxbayClickToCall.pending, (state) => {
      state.voxbayClickToCallLoading = true;
      state.voxbayClickToCallSuccess = false;
      state.voxbayClickToCallError = false;
    });
    builder.addCase(
      VoxbayAddLeadForUnknowns.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.voxbayAddLeadForUnknownLoading = false;
        state.voxbayAddLeadForUnknownSuccess = true;
        state.voxbayAddLeadForUnknownError = false;
        state.voxbayAddLeadForUnknownData = action?.payload;
      }
    );
    builder.addCase(
      VoxbayAddLeadForUnknowns.rejected,
      (state, action: AnyAction) => {
        state.voxbayAddLeadForUnknownLoading = false;
        state.voxbayAddLeadForUnknownSuccess = false;
        state.voxbayAddLeadForUnknownError =
          action?.error?.message || "Something went wrong";
      }
    );
    builder.addCase(VoxbayAddLeadForUnknowns.pending, (state) => {
      state.voxbayAddLeadForUnknownLoading = true;
      state.voxbayAddLeadForUnknownSuccess = false;
      state.voxbayAddLeadForUnknownError = false;
    });
  },
});

export default voxbaySlice.reducer;
export const {
  reset,
  resetVoxbayConnectSuccess,
  resetAddVoxbayAgentSuccess,
  resetDeactivateVoxbaySuccess,
  setShowVoxbayWidget,
  setShowVoxbayNumber,
  setHideVoxbayWidget,
  resetVoxbayClickToCallSuccess,
  resetVoxbayAddLeadForUnknownSuccess,
} = voxbaySlice.actions;
